import { faArrowLeft, faArrowRight, faX } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Masonry } from '@mui/lab';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import Carousel from 'react-bootstrap/Carousel';

const MasonryProperty = ({ photoGallery, onClick }) => {
    const [isModalGalleryOpen, setIsModalGalleryOpen] = useState(false);

    const { t } = useTranslation();

    const [currentIndex, setCurrentIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setCurrentIndex(selectedIndex);
    };

    const handleImageClick = (index) => {
        setCurrentIndex(index);
        setIsModalGalleryOpen(true);
    };

    useEffect(() => {
    }, [isModalGalleryOpen]);

    return (
        <>
            {!isModalGalleryOpen && (
                <>
                    <div className="modal-overlay" onClick={onClick}></div>
                    <div className="modalDetail modal-detail-villa position-fixed show background-white overflow-x-hidden">
                        <div className="modal-dialog">
                            <div className="modal-content px-md-5">
                                <div className="modal-header arrowEffectContainer paddingCustomModalContent d-flex justify-content-start">
                                    <button type="button" className="close" onClick={onClick}>
                                        <span className="text-uppercase"><a className="input-group-text nav-link ctaWidthMax115 ctaLink text-uppercase ps-5"><FontAwesomeIcon className="me-2 effectArrowLeft" icon={faArrowLeft} />{t("OverviewVilla")}</a></span>

                                    </button>
                                </div>

                                <Box className="d-flex justify-content-between h-100 flex-wrap">
                                    <Masonry columns={2} spacing={2}>
                                        {photoGallery && photoGallery.map((item, index) => {
                                            return (
                                                <div className="position-relative" key={index}>
                                                    <img
                                                        srcSet={`${process.env.REACT_APP_SITE_URL + item.objectUrl}?w=162&auto=format&dpr=2 2x`}
                                                        src={`${process.env.REACT_APP_SITE_URL + item.objectUrl}?w=162&auto=format`}
                                                        alt={item?.name}
                                                        loading="lazy"
                                                        className="masonry-info"
                                                        onClick={(e) => { e.preventDefault(); handleImageClick(index); }}
                                                    />
                                                </div>
                                            )
                                        })}
                                    </Masonry>
                                </Box>
                            </div>
                        </div>
                    </div>
                </>
            )}


            {isModalGalleryOpen && (
                <div
                    className="carousel-masonry"
                >
                    <div className="gradient-overlay-up-half z-1"></div>
                    <div className="modal-header">
                        <button
                            type="button"
                            className="position-absolute bg-transparent border-0 text-uppercase carousel-photo-gallery-button"
                            onClick={() => setIsModalGalleryOpen(false)}

                        >
                            <FontAwesomeIcon icon={faX} className="me-2" /> {t('Close')}
                        </button>
                    </div>
                    <div>
                        <Carousel
                            activeIndex={currentIndex}
                            onSelect={handleSelect}
                            interval={null}
                            className="carousel-banner"
                            nextIcon={<FontAwesomeIcon icon={faArrowRight} className="me-2" color="black" fontSize={"20px"} />}
                            prevIcon={<FontAwesomeIcon icon={faArrowLeft} className="me-2" color="black" fontSize={"20px"} />}
                        >
                            {photoGallery.map((item, index) => (
                                <Carousel.Item key={index}>
                                    <img
                                        className="d-block carousel-photo-gallery"
                                        src={process.env.REACT_APP_SITE_URL + item.objectUrl}
                                        alt={item?.name}
                                    />
                                </Carousel.Item>
                            ))}
                        </Carousel>
                        <div className="carousel-counter d-flex justify-content-center mt-4">
                            <p>{`${currentIndex + 1} / ${photoGallery.length}`}</p>
                        </div>

                    </div>
                </div>
            )}
        </>
    );
}

export default MasonryProperty;